import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import "rxjs/Rx";
import { Subject }    from 'rxjs/Subject';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AuthService } from "../../auth.service";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";

import { SharedModule, NumPipe, UtilsService } from "../../shared/shared.module";
import * as _ from "lodash";

declare let swal:any;

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css']
})
export class AdminDashboardComponent implements OnInit {

  isLoading: boolean = false;

  private _subscription;

  stats: any = {};

  constructor(
    private numPipe: NumPipe,
    public authService: AuthService,
    private http: HttpClient,
    private utilsService: UtilsService,
    private router: Router,
    private route: ActivatedRoute,
    public utils: UtilsService
  ) {
    this._subscription = authService.connectedAsChange.subscribe((value) => {
      this.loadStats();
    });

  }

  ngOnInit() {
   this.loadStats();
  }

  loadStats() {
    this.stats = {};
    if (this.authService.currentIsAdmin())
      this.getAdminStats();
    else
      this.getLaboStats();
  }

  getAdminStats() {
    this.isLoading = true;
    this.http.get(environment.API_PATH + '/admin/stats-dashboard', {withCredentials: true})
	  .subscribe(
      data => {
        this.isLoading = false;
        this.stats = data;
      },
      err => {
        this.isLoading = false;
        var errors = err.error;
        if (errors.error) {
          if (errors.error.status === 401) {

            this.router.navigate(['/connexion']);
          } else if (errors.error.status === 403) {
            if (errors.error.details.redirect)
              this.router.navigate([errors.error.details.redirect]);
            else
              this.router.navigate(['connexion']);
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
  }

  getLaboStats() {
    var query = "";
    if (this.authService.connectedAs.admin == false)
      query += "?connectedAsId=" + this.authService.connectedAs.id;

    this.isLoading = true;
    this.http.get(environment.API_PATH + '/laboratory/stats-dashboard' + query, {withCredentials: true})
	  .subscribe(
      data => {
        this.isLoading = false;
        this.stats = data;
      },
      err => {
        this.isLoading = false;
        var errors = err.error;
        if (errors.error) {
          if (errors.error.status === 401) {

            this.router.navigate(['/connexion']);
          } else if (errors.error.status === 403) {
            if (errors.error.details.redirect)
              this.router.navigate([errors.error.details.redirect]);
            else
              this.router.navigate(['connexion']);
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/admin-dashboard/admin-dashboard.component.ts